import React from "react";
import { SideMenu, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import VisaCardIcon from "./../../../assets/svg/visaCardIcon.svg";
import MasterCardIcon from "./../../../assets/svg/masterCardIcon.svg";
import MyWalletBalanceIcon from "./../../../assets/svg/myWalletBalanceIcon.svg";
import MyWalletEarningIcon from "./../../../assets/svg/myWalletEarningIcon.svg";
import MyWalletWithdrawIcon from "./../../../assets/svg/myWalletWithdrawIcon.svg";
import { Button } from "@mui/material";
import { MdModeEditOutline, MdDelete } from "react-icons/md";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useAlert } from "react-alert";
const MyWallet = () => {
  const alert = useAlert();
  const [addMoney, setAddMoney] = React.useState(false);
  const [addNewCard, setAddNewCard] = React.useState(false);
  const WithdrawHistoryTable = [
    {
      date: "JAN 4, 2022, 10:04 am",
      method: "Mastercard",
      amount: "$2000",
      status: "Panding",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      method: "Mastercard",
      amount: "$2000",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      method: "Mastercard",
      amount: "$2000",
      status: "cancelled",
    },
  ];

  // Add Money
  const [addMoneyCurrency, setAddMoneyCurrency] = React.useState("$");
  const [addMoneyAmount, setAddMoneyAmount] = React.useState("");
  const [addMoneyAmountMethod, setAddMoneyAmountMethod] = React.useState("");
  const [addMoneyLoading, setAddMoneyLoading] = React.useState(false);
  const addMoneyAmountRef = React.useRef();
  const addMoneyAmountMethodRef = React.useRef();
  const AddMoneyHandler = () => {
    if (addMoneyAmount === "") {
      alert.error(<div className="alert-message">please add your amount</div>);
      addMoneyAmountRef.current.focus();
    } else if (addMoneyAmountMethod === "") {
      alert.error(
        <div className="alert-message">please select amount method</div>
      );
      addMoneyAmountMethodRef.current.focus();
    } else {
      setAddMoneyLoading(true);
      const AddMoneyObject = {
        currency: addMoneyCurrency,
        amount: addMoneyAmount,
        method: addMoneyAmountMethod,
      };
      alert.success(
        <div className="alert-message">you have successfully add money</div>
      );
      console.log(AddMoneyObject);
      setTimeout(() => {
        setAddMoney(false);
        setAddMoneyLoading(false);
      }, 2000);
    }
  };

  // Add New Card
  const [cardHolderName, setCardHolderName] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState("");
  const [cvv, setCvv] = React.useState("");
  const [addNewCardLoading, setAddNewCardLoading] = React.useState(false);
  const cardHolderNameRef = React.useRef();
  const accountNumberRef = React.useRef();
  const expiryDateRef = React.useRef();
  const cvvRef = React.useRef();
  const AddNewCardHandler = () => {
    if (cardHolderName === "") {
      alert.error(<div className="alert-message">name required</div>);
      cardHolderNameRef.current.focus();
    } else if (accountNumber === "" || accountNumber.length < 16) {
      alert.error(
        <div className="alert-message">please enter valid account number</div>
      );
      accountNumberRef.current.focus();
    } else if (expiryDate === "") {
      alert.error(
        <div className="alert-message">please select expiry date</div>
      );
      expiryDateRef.current.focus();
    } else if (cvv === "") {
      alert.error(<div className="alert-message">please add cvv</div>);
      cvvRef.current.focus();
    } else {
      setAddNewCardLoading(true);
      const AddNewCardObject = {
        name: cardHolderName,
        accountNumber: accountNumber,
        expiryDate: expiryDate,
        cvv: cvv,
      };
      alert.success(
        <div className="alert-message">you have successfully add new card</div>
      );
      console.log(AddNewCardObject);
      setTimeout(() => {
        setAddNewCard(false);
        setAddNewCardLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu>
      <div className="my-wallet-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div
                className="my-wallet-header-card-container"
                style={{ backgroundColor: "#FBDCFF" }}
              >
                <div className="my-wallet-header-card-icon">
                  <img src={MyWalletBalanceIcon} />
                </div>
                <div className="my-wallet-header-card-data-main">
                  <p
                    className="my-wallet-header-card-heading"
                    style={{ color: "#690077" }}
                  >
                    Wallet Balance
                  </p>
                  <p className="my-wallet-header-card-price">$65,000</p>
                  <a
                    href="#"
                    className="my-wallet-add-money"
                    onClick={() => setAddMoney(true)}
                  >
                    Add money
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div
                className="my-wallet-header-card-container"
                style={{ backgroundColor: "#FFEFE3" }}
              >
                <div className="my-wallet-header-card-icon">
                  <img src={MyWalletEarningIcon} />
                </div>
                <div className="my-wallet-header-card-data-main">
                  <p
                    className="my-wallet-header-card-heading"
                    style={{ color: "#9D4300" }}
                  >
                    Total Earnings
                  </p>
                  <p className="my-wallet-header-card-price">$65,000</p>
                </div>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div
                className="my-wallet-header-card-container"
                style={{ backgroundColor: "#DCECFF" }}
              >
                <div className="my-wallet-header-card-icon">
                  <img src={MyWalletWithdrawIcon} />
                </div>
                <div className="my-wallet-header-card-data-main">
                  <p
                    className="my-wallet-header-card-heading"
                    style={{ color: "#003371" }}
                  >
                    Total withdrawals
                  </p>
                  <p className="my-wallet-header-card-price">$65,000</p>
                </div>
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div className="my-wallet-card-main">
                <p className="my-wallet-card-heading">Cards</p>
                <div className="table-data-container">
                  <table>
                    <tr>
                      <td className="my-wallet-card-table-icon">
                        <img src={VisaCardIcon} />
                      </td>
                      <td className="my-wallet-card-table-card-number">
                        1234 1234 1234 1234
                      </td>
                      <td className="my-wallet-card-table-card-title">Visa</td>
                      <td className="my-wallet-card-table-card-date">04/25</td>
                      <td className="my-wallet-card-table-card-username">
                        David Anderson
                      </td>
                      <td className="my-wallet-card-table-card-edit-button">
                        <Button>
                          <MdModeEditOutline color="#6B6B6B" size={25} />
                        </Button>
                      </td>
                      <td className="my-wallet-card-table-card-delete-button">
                        <Button>
                          <MdDelete color="#6B6B6B" size={25} />
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td className="my-wallet-card-table-icon">
                        <img src={MasterCardIcon} />
                      </td>
                      <td className="my-wallet-card-table-card-number">
                        1234 1234 1234 1234
                      </td>
                      <td className="my-wallet-card-table-card-title">
                        Master card
                      </td>
                      <td className="my-wallet-card-table-card-date">04/25</td>
                      <td className="my-wallet-card-table-card-username">
                        David Anderson
                      </td>
                      <td className="my-wallet-card-table-card-edit-button">
                        <Button>
                          <MdModeEditOutline color="#6B6B6B" size={25} />
                        </Button>
                      </td>
                      <td className="my-wallet-card-table-card-delete-button">
                        <Button>
                          <MdDelete color="#6B6B6B" size={25} />
                        </Button>
                      </td>
                    </tr>
                  </table>
                  <Button
                    className="view-details-button"
                    variant="text"
                    onClick={() => setAddNewCard(true)}
                  >
                    Add new Card +
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div className="my-wallet-card-main">
                <p className="my-wallet-card-heading">Withdraw your money</p>
                <div className="table-data-container">
                  <table>
                    <tr>
                      <td className="my-wallet-card-table-icon">
                        <img src={VisaCardIcon} />
                      </td>
                      <td className="my-wallet-card-table-card-number">
                        1234 1234 1234 1234
                      </td>
                      <td className="my-wallet-card-table-card-title">
                        Master card
                      </td>
                      <td className="my-wallet-card-table-card-date">04/25</td>
                      <td className="my-wallet-card-table-card-username">
                        David Anderson
                      </td>
                      <td className="my-wallet-card-table-card-delete-button">
                        <Button>
                          <IoIosCheckmarkCircle color="#663399" size={25} />
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td className="my-wallet-card-table-icon">
                        <img src={MasterCardIcon} />
                      </td>
                      <td className="my-wallet-card-table-card-number">
                        1234 1234 1234 1234
                      </td>
                      <td className="my-wallet-card-table-card-title">
                        Master card
                      </td>
                      <td className="my-wallet-card-table-card-date">04/25</td>
                      <td className="my-wallet-card-table-card-username">
                        David Anderson
                      </td>
                      <td className="my-wallet-card-table-card-delete-button">
                        <Button>
                          <IoIosCheckmarkCircle color="#663399" size={25} />
                        </Button>
                      </td>
                    </tr>
                  </table>
                  <div className="my-wallet-card-table-card-withdraw-main">
                    <div>
                      <p className="my-wallet-card-table-card-withdraw-price">
                        $65,000
                      </p>
                      <p className="my-wallet-card-table-card-withdraw-title">
                        current Balance
                      </p>
                    </div>
                    <Button
                      className="my-wallet-card-table-card-withdraw-button"
                      variant="text"
                    >
                      Withdraw money
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Withdraw History</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="withdraw-history-table-date-heading">Date</th>
                <th className="withdraw-history-table-method-heading">
                  Mathod
                </th>
                <th className="withdraw-history-table-amount-heading">
                  Amount
                </th>
                <th className="withdraw-history-table-status-heading">
                  Status
                </th>
              </tr>
              </thead>
              {WithdrawHistoryTable.map(
                (WithdrawHistoryTableValue, WithdrawHistoryTableIndex) => {
                  return (
                    <tr key={WithdrawHistoryTableIndex}>
                      <td className="table-date-data">
                        {WithdrawHistoryTableValue.date}
                      </td>
                      <td className="table-data">
                        {WithdrawHistoryTableValue.method}
                      </td>
                      <td className="table-data">
                        {WithdrawHistoryTableValue.amount}
                      </td>
                      <td className="table-data">
                        <div
                          className="my-wallet-withdraw-status-main"
                          style={{
                            backgroundColor:
                              WithdrawHistoryTableValue.status === "Panding"
                                ? "#FFD1B0"
                                : WithdrawHistoryTableValue.status ===
                                  "Complated"
                                ? "#D2FFEB"
                                : "#FFB0B0",
                            color:
                              WithdrawHistoryTableValue.status === "Panding"
                                ? "#B84D00"
                                : WithdrawHistoryTableValue.status ===
                                  "Complated"
                                ? "#098B51"
                                : "#B80000",
                          }}
                        >
                          {WithdrawHistoryTableValue.status}
                        </div>
                      </td>
                    </tr>
                  );
                }
              )}
            </table>
          </div>
        </div>
      </div>
      <Model
        modelTitle="Add money"
        width="md"
        onClose={() => setAddMoney(false)}
        open={addMoney}
        buttonTitle="Submit"
        buttonHandler={AddMoneyHandler}
        loading={addMoneyLoading}
      >
        <div className="form-container">
          <div className="my-wallet-add-money-model">
            <p className="my-wallet-add-money-model-username">David Anderson</p>
            <div className="my-wallet-add-money-model-price-main">
              <p className="my-wallet-add-money-model-heading">
                wallet balance
              </p>
              <p className="my-wallet-add-money-model-price">$65,000</p>
            </div>
          </div>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">add Amount</p>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select
                        className="country-code-picker-dropdown"
                        onChange={(e) => setAddMoneyCurrency(e.target.value)}
                      >
                        <option value="$">$</option>
                        <option value="£">£</option>
                        <option value="€">€</option>
                      </select>
                    </div>
                    <div className="country-flag-main">
                      <input
                        type="number"
                        name="amount"
                        className="mobile-number-input"
                        placeholder=""
                        value={addMoneyAmount}
                        ref={addMoneyAmountRef}
                        onChange={(e) => setAddMoneyAmount(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">select Amount</p>
                  <select
                    className="input"
                    ref={addMoneyAmountMethodRef}
                    onChange={(e) => setAddMoneyAmountMethod(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Visa Card">Visa Card</option>
                    <option value="Master Card">Master Card</option>
                  </select>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* Add new card */}
      <Model
        modelTitle="Add new card"
        width="md"
        onClose={() => setAddNewCard(false)}
        open={addNewCard}
        buttonTitle="Save"
        buttonHandler={AddNewCardHandler}
        loading={addNewCardLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Card holder name</p>
                  <input
                    type="text"
                    name="fullName"
                    className="input"
                    placeholder="card holder name"
                    value={cardHolderName}
                    ref={cardHolderNameRef}
                    onChange={(e) => setCardHolderName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Account number</p>
                  <input
                    type="number"
                    name="number"
                    className="input"
                    placeholder="XXXX XXXX XXXX XXXX"
                    value={accountNumber}
                    ref={accountNumberRef}
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Expiry date</p>
                  <input
                    type="date"
                    className="input"
                    placeholder="dd/mm"
                    value={expiryDate}
                    ref={expiryDateRef}
                    onChange={(e) => setExpiryDate(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">cvv</p>
                  <input
                    type="number"
                    name="cvv"
                    className="input"
                    placeholder="xxx"
                    value={cvv}
                    ref={cvvRef}
                    onChange={(e) => setCvv(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default MyWallet;
